import { httpClient, type HttpClient } from '../core'
import { conversationsEndpoints } from './conversations.endpoints'
import { conversationMessageSchema, conversationPageSchema, type ConversationMessageDto, type ConversationPageDto, type PostCommentBody } from './conversations.schemas'

/** A project's comments: read a page, add one. There is no edit and no delete. */
export class ConversationsService {
  private readonly http: HttpClient

  constructor(http: HttpClient = httpClient) {
    this.http = http
  }

  list(projectId: string, params: { page: number; pageSize: number }, signal?: AbortSignal): Promise<ConversationPageDto> {
    return this.http.get(conversationsEndpoints.collection(projectId), conversationPageSchema, { query: params, signal })
  }

  /** Never repeated by itself: a lost answer may still have saved the comment, and a second try would post it twice. */
  post(projectId: string, body: PostCommentBody, signal?: AbortSignal): Promise<ConversationMessageDto> {
    return this.http.post(conversationsEndpoints.collection(projectId), conversationMessageSchema, { body, signal })
  }
}

export const conversationsService = new ConversationsService()
